import ClientScoringInputParametersTable from './ClientScoringInputParametersTable';

export default ClientScoringInputParametersTable;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/scoring-input-parameters-table/index.js